import { config } from '../utils/config';

const url_prefix = config('api_url');

export {
  url_prefix
};
